import React from 'react';

const Header = () => {
  return (
    <div className="header">
      <h1>New Albums and Singles</h1>
    </div>
  );
}

export default Header;